var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app--container" },
    [
      _c("header", { staticClass: "header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "header--title" }, [
          _c("img", {
            attrs: { src: "/telechargement/content/logo.svg", alt: "" }
          }),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.$t("home")))])
        ]),
        _vm._v(" "),
        _c(
          "nav",
          {
            staticClass: "nav--lang",
            attrs: { "aria-label": "Choose language" }
          },
          [
            _c(
              "a",
              {
                attrs: { title: "Version française" },
                on: {
                  click: function($event) {
                    return _vm.setLanguage("fr")
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: "/telechargement/content/fr-flag.svg", alt: "" }
                }),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Version française")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { title: "English version" },
                on: {
                  click: function($event) {
                    return _vm.setLanguage("en")
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: "/telechargement/content/en-flag.svg", alt: "" }
                }),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("English version")
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("loadingPanel"),
      _vm._v(" "),
      _vm.dataInitialized
        ? _c("main", { staticClass: "main--container" }, [
            _c(
              "div",
              { staticClass: "router-view-content" },
              [_c("router-view")],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("footer", { staticClass: "footer" }, [
        _c("p", [
          _vm._v("\n            " + _vm._s(_vm.$t("footerMessage1"))),
          _c("a", { attrs: { href: "tel:+33175602900" } }, [
            _vm._v("+33 1 75 60 29 00")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("footerMessage2")) + " "),
          _c("a", { attrs: { href: "mailto:contact@fwa.eu" } }, [
            _vm._v("contact@fwa.eu")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header--logo-container" }, [
      _c(
        "a",
        { attrs: { href: "http://www.fwa.eu/", title: "Aller sur fwa.eu" } },
        [
          _c("img", {
            attrs: {
              src: "/telechargement/content/fwa.png",
              alt: "FWA développeurs d'idées."
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }